@if(isLoading()) {
    <div class="tw-w-full tw-flex tw-justify-center tw-py-3">
        <mat-spinner id="white-spinner" class="tw-h-100"></mat-spinner>
    </div>
} @else {
    <div class="tw-grid tw-grid-cols-5 tw-grid-rows-6 tw-gap-1" [ngStyle]="{'height': keyboardDimension + 'px'}">
        <div class="tw-col-span-5 tw-flex tw-flex-row tw-max-h-12">
            <div class="tw-flex tw-min-w-[40%]">
                <tilby-general-input-button class="sale-keypad-button tw-bg-transparent tw-truncate" [btn]="toggleMainKeyboardButton" [buttonFontSize]="34" />
                <app-tilby-keypad-display [value]="form.value.cashValue" class="tw-flex-1" inputClass="tw-text-xl"/>
            </div>
            <div class="tw-flex tw-flex-row tw-w-full">
                <div id="infoKeypadSide" class="tw-h-full tw-w-full tw-m-auto">
                    @if(lastSaleTotal) {
                        <div id="lastSaleTotal" class="tw-flex tw-flex-row tw-justify-center tw-items-center tw-font-bold tw-whitespace-nowrap tw-overflow-hidden" (click)="showLastSaleDocuments()">
                            <div class="tw-flex tw-flex-col tw-pr-4">
                                <div>{{ "CASHREGISTER.ACTIVE_SALE.KEYBOARD_SIDE_TOTAL" | translate }}</div>
                                @if(lastSaleTotal.change) {
                                    <div>{{ "CASHREGISTER.ACTIVE_SALE.KEYBOARD_SIDE_CHANGE" | translate }}</div>
                                }
                            </div>
                            <div class="tw-flex tw-flex-col tw-text-right">
                                @if(showPrices){
                                    <div>{{ lastSaleTotal.final_amount | tilbyCurrency }}</div>
                                } @else {
                                    <div>***</div>
                                }

                                @if(lastSaleTotal.change) {
                                    @if(showPrices){
                                        <div>{{ lastSaleTotal.change | tilbyCurrency }}</div>
                                    } @else {
                                        <div>***</div>
                                    }
                                }
                            </div>
                        </div>
                    } @else {
                        <div id="finalAmountAndQuantityId" class="tw-flex tw-flex-row tw-h-full">
                            <span id="finalAmountId" class="tw-h-fit tw-m-auto tw-whitespace-nowrap tw-overflow-hidden tw-px-2 tw-font-bold tw-w-full tw-text-right" [ngClass]="{'tw-h-full tw-leading-[1.9rem]' : keyboardDimension === 220, 'tw-py-1' : keyboardDimension !== 220}">
                                @if(showPrices){
                                    {{ (finalAmount || 0) | tilbyCurrency }}
                                } @else {
                                    ***
                                }
                            </span>
                            @if(sale) {
                                <span class="tw-p-1 tw-h-fit tw-rounded-md tw-bg-red-500 tw-font-bold tw-text-white">{{ totalQuantity }}</span>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
        <app-cashregister-keypad class="tw-col-span-3 tw-row-span-4 tw-text-2xl" [field]="cashValue" (fieldChange)="onFieldChange.emit($event)" [integerMultiply]="integerMultiply" [keyboardFontSize]="keyboardFontSize" />
        <div class="tw-grid tw-col-span-2 tw-row-span-4 tw-gap-1">
            @if(showButtonOpenDrawer) {
                <button
                    class="tw-h-full tilby-body-background-primary-color sale-keypad-button tw-text-xl tw-truncate tw-border-none"
                    [disabled]="disableShowButtonOpenDrawer"
                    tilbyGestures
                    [ngClass]="disableShowButtonOpenDrawer ? ['tw-opacity-25', 'tw-pointer-events-none'] : []"
                    (click)="openCashDrawer()">
                    <div class="tw-flex tw-flex-col tw-items-center">
                        <mat-icon>eject</mat-icon>
                        {{'CASHREGISTER.TOPBAR.OPEN_DRAWER_ACCESSIBILITY' | translate}}
                    </div>
                </button>
            } @else {
                @if(fastPaymentsButtons.length) {
                    @for(btn of fastPaymentsButtons; track btn) {
                        <button mat-button
                            class="tw-h-full tilby-body-background-primary-color sale-keypad-button tw-text-xl tw-truncate tw-whitespace-normal"
                            [ngClass]="btn.isDisable?.() ? ['tw-opacity-25', 'tw-pointer-events-none'] : []"
                            tilbyGestures
                            (longPress)="btn.longPress()"
                            (click)="btn.click()"
                            [disabled]="btn.isDisable?.()"
                            [style.--keyboard-font-size]="'20px'">
                            {{btn.name | translate}}
                        </button>
                    }
                } @else if(principalActionButton) {
                    <tilby-general-input-button
                        class="sale-keypad-button tw-truncate"
                        [ngClass]="principalActionButton.isDisable?.() ? ['tw-opacity-25', 'tw-pointer-events-none'] : []"
                        [btn]="principalActionButton"
                        [buttonFontSize]="keyboardFontSize"
                    />
                } @else {
                    @for(btn of actionButtons; track btn) {
                        <button mat-button
                            class="tw-h-full tw-border-solid tw-border-neutral-100 sale-keypad-button side-keyboard-action-button tw-text-xl tw-truncate"
                            [ngClass]="btn.isDisable?.() ? ['tw-opacity-25', 'tw-pointer-events-none', btn.class || ''] : [btn.class || '']"
                            tilbyGestures
                            (click)="btn.click()"
                            [disabled]="btn.isDisable?.()"
                            [style.--keyboard-font-size]="'15px'">
                            <div class="tw-flex tw-flex-col tw-items-center" style="height: 35px">
                                @if(btn.icon) {
                                    <mat-icon style="font-size: 18px">{{btn.icon()}}</mat-icon>
                                }
                                <p style="line-height: 2px;">{{btn.name | translate}}</p>
                            </div>
                        </button>
                    }
                }
            }
        </div>
        <div class="tw-grid tw-col-span-5 tw-grid-rows-1 tw-gap-1" [ngClass]="fastPaymentsButtons.length ? 'tw-grid-cols-5' : 'tw-grid-cols-4'">
            @for (btn of buttons; track btn) {
                @if (btn.isIt()) {
                    <tilby-general-input-button
                        [ngClass]="btn.isDisable?.() ? ['tw-opacity-25', 'tw-pointer-events-none'] : []"
                        class="sale-keypad-button sale-keypad-button__dark tw-truncate"
                        [class.tw-bg-green-500]="btn.selected?.()"
                        [btn]="btn"
                        [buttonFontSize]="keyboardFontSize"
                    />
                }
            }
            @if (fastPaymentsButtons.length && principalActionButton) {
                <tilby-general-input-button
                    class="sale-keypad-button tw-truncate"
                    [ngClass]="principalActionButton.isDisable?.() ? ['tw-opacity-25', 'tw-pointer-events-none'] : []"
                    [btn]="principalActionButton"
                    [buttonFontSize]="keyboardFontSize"
                />
            }
        </div>
    </div>
}

